"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Payment extends base_1.default {
    getPaymentInfo() {
        return this.get(`/getUserPaymentInfo`, {});
    }
    addOrUpdatePayment(data) {
        return this.put('/userPaymentUpdate/', data);
    }
}
exports.default = new Payment();
